<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Repeated QR Mapping</h2>
            </div>
            <div class="p-2 bd-highlight" style="width: 200px;">
                <div class="row position-relative">
                    <input
                        type="text"
                        class="form-control pr-5"
                        placeholder="Search by Nomor Mesin"
                        v-model="engine_no"
                    />
                    <span
                        class="position-absolute"
                        style="right: 15px; top: 50%; transform: translateY(-50%); color: #aaa; pointer-events: none;"
                    >
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </div>
        <repeated-mapping-table 
            class="mt-4"
            :engine_no="engine_no"
        ></repeated-mapping-table>
    </div>
</template>


<script>
import repeatedMappingTable from './children/repeatedMappingTable.vue'

export default {
    metaInfo : {
        title : 'QR Repeated Mapping'
    },
    components : {
        repeatedMappingTable
    },
    data() {
        return {
            engine_no: ''
        }
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
}
</script>

<style>
    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }

    .h-47px {
        height: 47px;
    }
</style>